// Downloadable launch templates per account family. Mirrors the families in
// apps/app-backend/utils/launchTemplateDownload.js, which is what actually
// authorizes the download; this list only decides which buttons to show.
const FAMILIES = [
  {
    matches: (name) => ['crimtan', 'crimtan-test'].includes(name),
    templates: [
      { platform: 'dv360', filename: 'Stellair_DV360_Launch_Template_V2.3.xlsx', label: 'DV360 v2.3 (.xlsx)' },
      { platform: 'yahoo', filename: 'Stellair_Yahoo_Launch_Template_v1.3.xlsx', label: 'Yahoo v1.3 (.xlsx)' },
    ],
  },
  {
    // Same match as isIdfcAccount in the backend's utils/idfcUtils.js.
    matches: (name) => name === 'idfc' || name.startsWith('idfc-'),
    templates: [
      { platform: 'g-ads-search', filename: 'IDFC_Search_Launch_Template.xlsx', label: 'Search (.xlsx)' },
      { platform: 'g-ads-pmax', filename: 'IDFC_PMax_Launch_Template.xlsx', label: 'PMax (.xlsx)' },
      { platform: 'g-ads-demandgen', filename: 'IDFC_DemandGen_Launch_Template.xlsx', label: 'Demand Gen (.xlsx)' },
    ],
  },
];

export function launchTemplatesFor(accountName) {
  const name = (accountName || '').trim().toLowerCase();
  return FAMILIES.find((family) => family.matches(name))?.templates || [];
}
